module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAARklEQVRIie3XIQ4AIAxD0Y5wVywn4OoQUPMkq/lVcy+da4y5tgxpDvSmpzuKzPdhW2NgYGBgYGBgYGBg4P/kJVG6oTyNJR2AmwST0u8yFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx.png
// module id = wUK+
// module chunks = 1